import { useMutation } from '@tanstack/react-query';

import { AxiosError } from 'axios';

import {
  PostV2ProjectsPrototypesPagesByProjectIdAndPrototypeIdBody,
  TPrototypePageDto,
  useAvApi,
} from '@app-velocity/av-api-v2';

export const useCreateScenarioPageMutation = (
  workspaceId?: string,
  signal?: AbortSignal
) => {
  const { prototypes } = useAvApi();

  return useMutation<
    TPrototypePageDto | undefined,
    AxiosError,
    {
      page: PostV2ProjectsPrototypesPagesByProjectIdAndPrototypeIdBody;
      prototypeId: string;
    }
  >({
    mutationKey: ['create-scenario-page-mutation'],
    mutationFn: async ({
      page,
      prototypeId,
    }: {
      page: PostV2ProjectsPrototypesPagesByProjectIdAndPrototypeIdBody;
      prototypeId: string;
    }) => {
      if (!workspaceId) return;

      const pageData = new FormData();
      pageData.append('index', page.index);
      pageData.append('image', page.image);
      pageData.append('name', page.name);
      pageData.append('data', page.data);
      pageData.append('fileName', page.fileName);

      // TODO fix any
      /* eslint-disable */
      const res =
        await prototypes.postV2ProjectsPrototypesPagesByProjectIdAndPrototypeId(
          pageData as any,
          {
            projectId: workspaceId,
            prototypeId,
          },
          {
            headers: {
              'Content-Type': 'multipart/form',
            },
            signal,
          }
        );
      /* eslint-disable */
      return res.data;
    },
  });
};
